import React from 'react';
import { updateProduct, updateResponse, getBranches, getProduct, getPrimaryProductById } from "../../api/productapi";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Form, Input, Label, Button, Row, Col, InputGroup } from 'reactstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CustomDatePicker from '../CustomDatePicker';
import FormValidator from '../FormValidation';
import cloneDeep from 'lodash/cloneDeep';
import { formatDateFields, formatInTimeZoneDate, formatInTimeZoneDateTime } from '../../helpers';
import PopupError from '../PopupError';
import CardTitle from '../CardTitle';
import '../css/EditCreate.css';
import * as Constants from '../../store/Constants'
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import InputFeedback from '../utils/InputFeedback';
import feedback from '../utils/feedback';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'reactstrap';
import { getPermission } from '../../api/userapi'

class ProductEdit extends React.Component {

    constructor(props) {
        super(props);
        this.props.route.history.push('/secure/products');
        this.props.route.history.push(this.props.route.match.url);
        this.validator = new FormValidator([
            {
                field: 'displayName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'displayName',
                method: (fieldValue, blackList) => {
                    let ret = false
                    if (!fieldValue) {
                        return ret
                    }
                    for (let c of fieldValue) {
                        if (blackList.includes(c)) {
                            ret = true;
                        }
                    }
                    return ret
                },
                args: [Constants.editorExcludeCharacters],
                validWhen: false,
                message: 'Value has invalid characters.'
            },
            {
                field: 'longDescription',
                method: (fieldValue, blackList) => {
                    let ret = false
                    if (!fieldValue) {
                        return ret
                    }
                    const text = fieldValue.replace(/(<([^>]+)>)/gi, "")
                    for (let c of text) {
                        if (blackList.includes(c)) {
                            ret = true;
                        }
                    }
                    return ret
                },
                args: [Constants.editorExcludeCharacters],
                validWhen: false,
                message: 'Value has invalid characters.'
            },
            {
                field: 'longDescription',
                method: (fieldValue) => {
                    const processedLongDescription = fieldValue.replace(/<[^>]*>?/gm, '').trim();
                    return processedLongDescription === ''
                },
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'shortDescription',
                method: (fieldValue, blackList) => {
                    let ret = false
                    if (!fieldValue) {
                        return ret
                    }
                    const text = fieldValue.replace(/(<([^>]+)>)/gi, "")
                    for (let c of text) {
                        if (blackList.includes(c)) {
                            ret = true;
                        }
                    }
                    return ret
                },
                args: [Constants.editorExcludeCharacters],
                validWhen: false,
                message: 'Value has invalid characters.'
            },
            {
                field: 'shortDescription',
                method: (fieldValue) => {
                    const processedLongDescription = fieldValue.replace(/<[^>]*>?/gm, '').trim();
                    return processedLongDescription === ''
                },
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'legalDisclosure',
                method: (fieldValue, blackList) => {
                    let ret = false
                    if (!fieldValue) {
                        return ret
                    }
                    const text = fieldValue.replace(/(<([^>]+)>)/gi, "")
                    for (let c of text) {
                        if (blackList.includes(c)) {
                            ret = true;
                        }
                    }
                    return ret
                },
                args: [Constants.editorExcludeCharacters],
                validWhen: false,
                message: 'Value has invalid characters.'
            },
            {
                field: 'cost',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'branchName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            },
            {
                field: 'startDate',
                method: this.isAlternate,
                validWhen: true,
                message: 'Start date is required for alternate product.'
            },
            {
                field: 'endDate',
                method: this.isAlternate,
                validWhen: true,
                message: 'End date is required for alternate product.'
            },
            {
                field: 'towing',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'entitlements',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'battery',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'lockout',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'fuel',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'flat',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'enrollmentFee',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
        ]);
        let product = null;
        if (this.props.route.state)
            if (this.props.route.state.product)
                product = this.props.route.state.product;
        this.state = {
            readOnly: true,
            product: product,
            cancel: false,
            saved: false,
            error: false,
            tooltipOpen: false,
            edit: false,
            validation: this.validator.valid(),
            baseState: '',
            branches: [],
            errorMessage: [],
            productId: this.props.route.match.params.productId ? this.props.route.match.params.productId : ''

        };

        this.closeModal = this.closeModal.bind(this);
        this.permissions = getPermission();
    }
    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAlternate = (confirmation, state) => (state.isPrimaryProduct ? confirmation == '' : confirmation != '');

    componentDidMount() {
        this.props.getBranches(function (result, _this) { _this.getData(result, _this) }, this)
        if (this.state.product == null) {
            const productId = this.props.route.match.params.productId;
            this.props.getProduct(function (result, _this) { _this.getDataProduct(result, _this) }, this, productId)
        } else if (this.props.route.location.state.productId) {
            this.props.getProduct(function (result, _this) { _this.getDataProduct(result, _this) }, this, this.state.productId)
        }
    }

    componentWillUnmount() {
        if (this.removeMessageEventListener === true)
            window.removeEventListener("message", this.messageHandler)
    }

    getDataProduct(data, _this) {
        var x = JSON.stringify(cloneDeep(data.data.data))
        _this.setState({
            product: data.data.data,
            baseState: x,
            _startDate: !data.data.data.startDate ? '' : formatInTimeZoneDate(data.data.data.startDate, data.data.data.branchIanaTimeZoneId),
            _endDate: !data.data.data.endDate ? '' : formatInTimeZoneDate(data.data.data.endDate, data.data.data.branchIanaTimeZoneId),
            originalPrimary: data.data.data.isPrimaryProduct,
        })
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        if (this.props.updateResult !== prevProps.updateResult) {
            var result = this.props.updateResult
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    var x = JSON.stringify(cloneDeep(this.state.product));
                    this.setState(state => ({
                        baseState: x,
                        saved: true,
                        edit: false,
                        validation: this.validator.valid(),
                        readOnly: !state.readOnly,
                        _startDate: !state.product.startDate ? '' : formatInTimeZoneDate(state.product.startDate + "T00:00:00", state.product.branchIanaTimeZoneId),
                        _endDate: !state.product.endDate ? '' : formatDateFields(state.product.endDate + "T00:00:00", state.product.branchIanaTimeZoneId)
                    }));
                    this.props.getProduct(function (result, _this) { _this.getDataProduct(result, _this) }, this, this.state.product.productId)
                } else if (result.data.success === false) {
                    const errorList = result.data.errors.map(e => e.message)
                    this.setState({ error: true, errorMessage: errorList })
                }
                else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    this.setState({ error: true, errorMessage: message });
                }
                this.props.updateResponse("");
            }
        }
    }

    toggleTooltip = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    renderBranchNames() {
        let branches = this.state.branches;
        return branches.map((branch) => {
            return (
                <option value={branch.branchId} key={branch.branchId}>{branch.name}</option>
            );
        });
    }

    getData(data, _this) {
        _this.setState({
            branches: data.data.data,
            loading: false
        });
    }

    //Removes the readonly attribute on edit and hides edit button / save and cancel buttons appear
    handleEdit() {
        this.setState(state => ({
            readOnly: !state.readOnly,
            edit: true
        }));
    }

    handleCancel = () => {
        //Cancel while editing
        if (this.state.edit) {
            this.setState(state => ({
                readOnly: true,
                product: JSON.parse(state.baseState),
                edit: false,
                //sets validation to previous state
                validation: this.validator.valid()
            }))
            document.getElementById("startDate").value = !this.state.product.startDate ? "" : this.state.product.startDate.substring(0, 10);
            document.getElementById("endDate").value = !this.state.product.endDate ? "" : this.state.product.endDate.substring(0, 10);

            this.submitted = false;

            //Removes the is-invalid class from all inputs when editing is canceled
            var els = document.getElementsByClassName('is-invalid')
            while (els[0]) {
                els[0].classList.remove('is-invalid')
            }

            //Cancel to go to list view
        } else {
            this.setState({
                cancel: true
            })
        }
    }

    handleFormSubmit = event => {
        event.preventDefault();
        var updVal = this.state.product;
        updVal.name = updVal.name.trim();
        updVal.displayName = updVal.displayName.trim()
        updVal.startDate = document.getElementById("startDate").value;
        updVal.endDate = document.getElementById("endDate").value;
        this.setState({ product: updVal }, () => {
            const validation = this.validator.validate(this.state.product);
            this.setState({ validation });
            this.submitted = true;
            if (validation.isValid) {
                // handle actual form submission here
                this.props.updateProduct(updVal);
            }
        });
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    closeModal() {
        this.setState({ error: false });
        this.submitted = false;
    }

    messageHandler = event => {
        if (event.origin === this.props.publicSiteBaseUrl && event.data === 'PreviewProduct')
            event.source.postMessage({ ...this.state.product }, event.origin)
    }

    handleSubmit = (event) => {
        event.preventDefault();
        window.open(`${this.props.publicSiteBaseUrl}/preview-membership/`, '_blank').focus();
        window.addEventListener("message", this.messageHandler);
        this.removeMessageEventListener = true;
    }

    handleResettoPrimary = (event) => {
        getPrimaryProductById(this.state.product.productLevelId, this.state.product.branchId)
            .then((res) => {
                const productPrimary = res.data.data;
                this.setPrimaryProduct(productPrimary);
            }).catch((err) => {
                console.log(err);
            });
    }

    setPrimaryProduct(productPrimary) {
        this.setState(prevState => ({
            product: {
                ...prevState.product, cost: productPrimary.cost,
                costPerAssociate: productPrimary.costPerAssociate,
                freeAssociatesAllowedNumber: productPrimary.freeAssociatesAllowedNumber,
                name: productPrimary.name,
                shortDescription: productPrimary.shortDescription,
                longDescription: productPrimary.longDescription,
                legalDisclosure: productPrimary.legalDisclosure,
                towing: productPrimary.towing,
                entitlements: productPrimary.entitlements,
                battery: productPrimary.battery,
                mileageException: productPrimary.mileageException,
                flat: productPrimary.flat,
                lockout: productPrimary.lockout,
                fuel: productPrimary.fuel,
                branchName: productPrimary.branchName,
                enrollmentFee: productPrimary.enrollmentFee,
                productStatus: productPrimary.productStatus,
                branchIanaTimeZoneId: productPrimary.branchIanaTimeZoneId,
            }
        }))
    }

    render() {
        const product = this.state.product;

        //Redirects to product when canceled
        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/products`,
                }}
            />;
        }

        let validation = this.submitted ?                         // if the form has been submitted at least once
            this.validator.validate(this.state.product) :   // then check validity every time we render
            this.state.validation                   // otherwise just use what's in state

        console.log(product);
        if (document.querySelector('.nativeDatePicker')) document.querySelector('.nativeDatePicker').style.display = 'none';
        return (
            <div className="card">

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage}
                />

                <CardTitle
                    component={"Product"}
                    readOnly={this.state.readOnly} />

                {product && <div className="card-body fs-12">
                    <Form>
                        <RequiredFieldNotation />
                        <div className="row">
                            <div className="col-md-12">
                                <Col>
                                    <Row>
                                        <Col>
                                            <Label htmlFor='productLevel' className="required-hint mt-4"><strong>Product Level</strong></Label>
                                            <Input readOnly
                                                type="input"
                                                maxLength="150"
                                                id='productLevel'
                                                required={this.submitted}
                                                title=""
                                                value={product.name}
                                                onChange={(e) => { this.isInvalid(e); var x = product; x.name = e.target.value; this.setState({ product: x }) }} />
                                        </Col>
                                        <Col className={`${validation.branchName.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='branchIdSelect' className="required-hint mt-4"><strong>Branch</strong></Label>
                                            <div className='select-disabled'>
                                                <select
                                                    id="branchIdSelect"
                                                    className='form-control'
                                                    value={product.branchId}
                                                    required={this.submitted}
                                                    title=""
                                                    disabled
                                                    onChange={(e) => {
                                                        const text = e.target.options[e.target.selectedIndex].text;
                                                        const value = e.target.value;
                                                        this.setState(prevState => ({ product: { ...prevState.product, branchId: value, branchName: text } }))
                                                    }}
                                                >
                                                    {this.renderBranchNames()}
                                                </select>
                                            </div>
                                            <span className="help-block">{validation.branchName.message}</span>
                                        </Col>
                                        <Col className={`${validation.displayName.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='productDisplayName' className="required-hint mt-4"><strong>Product-Branch Display Name</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                type="input"
                                                className={this.state.readOnly ? '' : 'input-editable-product'}
                                                maxLength="150"
                                                id='productDisplayName'
                                                required={this.submitted}
                                                title=""
                                                value={product.displayName}
                                                onKeyDown={e => {
                                                    if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                        e.preventDefault()
                                                    }
                                                }}
                                                onChange={e => {
                                                    const value = e.target.value;
                                                    this.setState(prevState => ({ product: { ...prevState.product, displayName: value } }))
                                                }} />
                                            {!this.state.readOnly && <InputFeedback feedbackText={feedback.productDisplayName} id='productDisplayName' />}
                                            <span className="help-block">{validation.displayName.message}</span>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <Col>
                                    <Row>
                                        {this.permissions.isAdmin &&
                                            <Col className="col-md-4">
                                                <div className="position-relative form-check form-check-inline mt-4">
                                                    <Input readOnly={this.state.readOnly}
                                                        className="ml-2"
                                                        type="checkbox"
                                                        id="productIsPrimary"
                                                        disabled={this.state.readOnly || (!this.state.originalPrimary && product.existsPrimaryProduct)}
                                                        checked={product.isPrimaryProduct}
                                                        onChange={e => {
                                                            const value = e.target.checked;
                                                            if (value) {
                                                                var x = product; x.startDate = ""; x.endDate = ""; this.setState({ product: x })
                                                            }
                                                            this.setState(prevState => ({ product: { ...prevState.product, isPrimaryProduct: value } }))
                                                        }} />
                                                    <Label htmlFor='productIsPrimary' className="form-check-label"><strong>Is Primary Product</strong></Label>
                                                    <InputFeedback feedbackText={!product.isPrimaryProduct ? feedback.primaryProduct : ''} id='productIsPrimary' />
                                                </div>
                                            </Col>
                                        }
                                        <Col>
                                            <p className={product.isPrimaryProduct ? 'primary-product mt-4' : 'alternate-product mt-4'}>
                                                {product.isPrimaryProduct ? `This Product is the Primary ${product.name} product for ${product.branchName}.`
                                                    : product.existsSeveralAlternate ? `This Product is an Alternate ${product.name} product for ${product.branchName}.`
                                                        : `This Product is the Alternate ${product.name} product for ${product.branchName}.`}</p>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <Col className={`${validation.shortDescription.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <div className="required-hint inline-label div-label-margin mt-4"><strong>Short Description</strong></div>
                                    {!this.state.readOnly &&
                                        <>
                                            <ReactQuill
                                                className={this.state.readOnly ? 'reactquill-field-smaller' : 'reactquill-field-smaller widget'}
                                                theme="snow"
                                                id='productShortDescription'
                                                readOnly={this.state.readOnly}
                                                modules={{
                                                    toolbar: Constants.editorToolbar
                                                }}
                                                preserveWhitespace={true}
                                                value={product.shortDescription}
                                                onKeyDown={e => {
                                                    if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                        e.preventDefault()
                                                    }
                                                }}
                                                onChange={value => {
                                                    if (value.length < 2000) {
                                                        this.setState(prevState => ({ product: { ...prevState.product, shortDescription: value } }))
                                                    } else {
                                                        this.setState(prevState => ({ product: { ...prevState.product } }))
                                                    }
                                                }}
                                            />
                                            <InputFeedback feedbackText={feedback.productShortDescription} id='productShortDescription' />
                                        </>
                                    }
                                    {this.state.readOnly && <div style={{ borderStyle: "none" }} className="ql-container ql-snow reactquill-field-smaller editor-readonly">
                                        <div className='ql-editor' dangerouslySetInnerHTML={{ __html: product.shortDescription }}></div>
                                    </div>}
                                    <span className="help-block">{validation.shortDescription.message}</span>
                                </Col>
                                <Col className={`${validation.longDescription.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <div className="required-hint inline-label div-label-margin mt-4"><strong>Long Description</strong></div>
                                    {!this.state.readOnly &&
                                        <>
                                            <ReactQuill
                                                className={this.state.readOnly ? 'reactquill-field' : 'reactquill-field widget'}
                                                theme="snow"
                                                id='productLongDescription'
                                                readOnly={this.state.readOnly}
                                                modules={{
                                                    toolbar: Constants.editorToolbar
                                                }}
                                                preserveWhitespace={true}
                                                value={product.longDescription}
                                                onKeyDown={e => {
                                                    if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                        e.preventDefault()
                                                    }
                                                }}
                                                onChange={value => {
                                                    this.setState(prevState => ({ product: { ...prevState.product, longDescription: value } }))
                                                }}
                                            />
                                            <InputFeedback feedbackText={feedback.productLongDescription} id='productLongDescription' />
                                        </>
                                    }
                                    {this.state.readOnly && <div style={{ borderStyle: "none" }} className="ql-container ql-snow reactquill-field editor-readonly">
                                        <div className='ql-editor' dangerouslySetInnerHTML={{ __html: product.longDescription }}></div>
                                    </div>}
                                    <span className="help-block">{validation.longDescription.message}</span>
                                </Col>
                                <Col className={`${validation.legalDisclosure.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <div className="inline-label div-label-margin mt-4"><strong>Legal Disclosure</strong></div>
                                    {!this.state.readOnly &&
                                        <>
                                            <ReactQuill
                                                className={this.state.readOnly ? 'reactquill-field-smaller' : 'reactquill-field-smaller widget'}
                                                theme="snow"
                                                id='productLegalDisclosure'
                                                readOnly={this.state.readOnly}
                                                modules={{
                                                    toolbar: Constants.editorToolbar
                                                }}
                                                preserveWhitespace={true}
                                                value={product.legalDisclosure}
                                                onKeyDown={e => {
                                                    if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                        e.preventDefault()
                                                    }
                                                }}
                                                onChange={value => {
                                                    this.setState(prevState => ({ product: { ...prevState.product, legalDisclosure: value } }))
                                                }}
                                            />
                                            <InputFeedback feedbackText={feedback.productLegalDisclosure} id='productLegalDisclosure' />
                                        </>
                                    }
                                    {this.state.readOnly && <div style={{ borderStyle: "none", marginBottom: 22 }} className="ql-container ql-snow reactquill-field-smaller editor-readonly">
                                        <div className='ql-editor' dangerouslySetInnerHTML={{ __html: product.legalDisclosure }}></div>
                                    </div>}
                                    <span className="help-block">{validation.legalDisclosure.message}</span>
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Row form>
                                        <Col className={`${validation.towing.isInvalid && this.submitted ? 'has-error-product' : ''}`} style={{ marginBottom: 17 }}>
                                            <Label htmlFor='towing' className="required-hint mt-4"><strong>Towing Miles</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                id="towing"
                                                type="input"
                                                maxLength="2000"
                                                required
                                                className={this.state.readOnly ? '' : 'input-editable-product'}
                                                value={product.towing}
                                                onChange={(e) => { var x = product; x.towing = e.target.value; this.setState({ product: x }) }} />
                                            <span className="help-block">{validation.towing.message}</span>
                                        </Col>
                                        <Col className={`${validation.entitlements.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='entitlements' className="required-hint mt-4"><strong>Service Calls per Year</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                id="entitlements"
                                                type="input"
                                                maxLength="255"
                                                className={this.state.readOnly ? '' : 'input-editable-product'}
                                                value={product.entitlements}
                                                onChange={(e) => { var x = product; x.entitlements = e.target.value; this.setState({ product: x }) }} />
                                            <span className="help-block">{validation.entitlements.message}</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col className={`${validation.battery.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <Label htmlFor='battery' className="required-hint mt-4"><strong>Battery Service</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="battery"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        maxLength="255"
                                        onChange={(e) => { var x = product; x.battery = e.target.value; this.setState({ product: x }) }}
                                        value={product.battery} />
                                    <span className="help-block">{validation.battery.message}</span>
                                </Col>
                                <Col className={`${validation.lockout.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <Label htmlFor='lockout' className="required-hint mt-4"><strong>Lockout Service</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="lockout"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        maxLength="255"
                                        onChange={(e) => { var x = product; x.lockout = e.target.value; this.setState({ product: x }) }}
                                        value={product.lockout} />
                                    <span className="help-block">{validation.lockout.message}</span>
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Label htmlFor='mileageException' className="mt-4"><strong>Towing Miles Exception</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="mileageException"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        maxLength="255"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        value={product.mileageException}
                                        onChange={(e) => { var x = product; x.mileageException = e.target.value; this.setState({ product: x }) }} />
                                    <span className="help-block"></span>
                                </Col>
                                <Col className={`${validation.flat.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <Label htmlFor='flat' className="required-hint mt-4"><strong>Flat Tire Change</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="flat"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        maxLength="255"
                                        onChange={(e) => { var x = product; x.flat = e.target.value; this.setState({ product: x }) }}
                                        value={product.flat} />
                                    <span className="help-block">{validation.flat.message}</span>
                                </Col>
                                <Col className={`${validation.fuel.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <Label htmlFor='fuel' className="required-hint mt-4"><strong>Fuel Delivery</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="fuel"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        maxLength="255"
                                        onChange={(e) => { var x = product; x.fuel = e.target.value; this.setState({ product: x }) }}
                                        value={product.fuel} />
                                    <span className="help-block">{validation.fuel.message}</span>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <hr style={{ border: '1.4px solid #4798d2', marginTop: '1.5rem !important', marginBottom: 0, width: '97%' }} />
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Row>
                                        <Col className={`${validation.cost.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='productCost' className="required-hint mt-4"><strong>Price</strong></Label>
                                            <InputGroup>
                                                <div className="input-group-prepend">
                                                    <span className={this.state.readOnly ? "input-group-text noborder" : "input-group-text currency-span"}>
                                                        $
                                                    </span>
                                                </div>
                                                <Input readOnly={this.state.readOnly}
                                                    type="number"
                                                    id='productCost'
                                                    className={this.state.readOnly ? '' : 'input-editable-product-currency noborder-left'}
                                                    maxLength="150"
                                                    step="0.01"
                                                    min="0"
                                                    required
                                                    title=""
                                                    value={this.state.readOnly ? parseFloat(product.cost).toFixed(2) : product.cost}
                                                    onBlur={(e) => { e.target.value = parseFloat(e.target.value).toFixed(2); var x = product; x.cost = e.target.value; this.setState({ product: x }) }}
                                                    onChange={(e) => { var x = product; x.cost = e.target.value; this.setState({ product: x }) }} />
                                            </InputGroup>
                                            {!this.state.readOnly && <InputFeedback feedbackText={feedback.productCost} id='productCost' />}
                                            <span className="help-block">{validation.cost.message}</span>
                                        </Col>
                                        <Col className={`${validation.enrollmentFee.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='enrollmentFee' className="required-hint mt-4"><strong>Enrollment Fee</strong></Label>
                                            <InputGroup>
                                                <div className="input-group-prepend">
                                                    <span className={this.state.readOnly ? "input-group-text noborder" : "input-group-text currency-span"}>
                                                        $
                                                    </span>
                                                </div>
                                                <Input readOnly={this.state.readOnly}
                                                    id="enrollmentFee"
                                                    type="number"
                                                    className={this.state.readOnly ? '' : 'input-editable-product-currency noborder-left'}
                                                    maxLength="150"
                                                    step="0.01"
                                                    min="0"
                                                    value={this.state.readOnly ? parseFloat(product.enrollmentFee).toFixed(2) : product.enrollmentFee}
                                                    onBlur={(e) => { e.target.value = parseFloat(e.target.value).toFixed(2); var x = product; x.enrollmentFee = e.target.value; this.setState({ product: x }) }}
                                                    onChange={(e) => { var x = product; x.enrollmentFee = e.target.value; this.setState({ product: x }) }} />
                                            </InputGroup>
                                            <span className="help-block">{validation.enrollmentFee.message}</span>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col style={{ marginBottom: 50 }}>
                                    <Row form>
                                        <Col>
                                            <Label htmlFor='costPerAssociate' className="mt-4">
                                                <strong>
                                                    Price per Associate{' '}
                                                    <FontAwesomeIcon
                                                        id="priceInfo"
                                                        icon={faInfoCircle}
                                                        className="text-info purple-tooltip"
                                                    />
                                                </strong>
                                            </Label>
                                            <Tooltip
                                                placement="top"
                                                isOpen={this.state.tooltipOpen}
                                                target="priceInfo"
                                                toggle={this.toggleTooltip}
                                            >
                                                To disable Associates on this product, set price to $0.
                                            </Tooltip>
                                            <InputGroup>
                                                <div className="input-group-prepend">
                                                    <span className={this.state.readOnly ? "input-group-text noborder" : "input-group-text currency-span"}>
                                                        $
                                                    </span>
                                                </div>
                                                <Input readOnly={this.state.readOnly}
                                                    id="costPerAssociate"
                                                    type="number"
                                                    className={this.state.readOnly ? '' : 'input-editable-product noborder-left'}
                                                    maxLength="150"
                                                    step="0.01"
                                                    min="0"
                                                    value={this.state.readOnly ? parseFloat(product.costPerAssociate).toFixed(2) : product.costPerAssociate}
                                                    onBlur={(e) => { e.target.value = parseFloat(e.target.value).toFixed(2); var x = product; x.costPerAssociate = e.target.value; this.setState({ product: x }) }}
                                                    onChange={(e) => { var x = product; x.costPerAssociate = e.target.value; this.setState({ product: x }) }} />
                                            </InputGroup>
                                        </Col>
                                        <Col>
                                            <Label htmlFor='freeAssociatesAllowed' className="required-hint mt-4"><strong>Free Associates</strong></Label>
                                            <div className={this.state.readOnly ? 'select-disabled' : 'select'}>
                                                <select
                                                    id="freeAssociatesAllowed"
                                                    className={this.state.readOnly ? 'form-control' : 'input-editable-product form-control'}
                                                    value={this.state.readOnly ? parseInt(product.freeAssociatesAllowedNumber) : product.freeAssociatesAllowedNumber}
                                                    disabled={this.state.readOnly}
                                                    onChange={(e) => { this.isInvalid(e); var x = product; x.freeAssociatesAllowedNumber = e.target.value; this.setState({ product: x }) }}>
                                                    <option>0</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5</option>
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <hr style={{ border: '1.4px solid #4798d2', marginTop: 0, marginBottom: 0, width: '97%' }} />
                            </div>
                            <div className={product.isPrimaryProduct ? 'col-md-6 hide' : 'col-md-6'} >
                                <Col>
                                    {!this.state.readOnly && <Row form>
                                        <Col className={` ${validation.startDate.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='startDate' className="required-hint mt-4"><strong>Staxt Date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={this.state.readOnly}
                                                className="input-date"
                                                defValue={!product.startDate ? "" : formatInTimeZoneDate(product.startDate, product.branchIanaTimeZoneId).substring(0, 10)}
                                                label="Start Date"
                                                overlayClass="location-datepicker-overlay"
                                                onChange={(date) => {

                                                    const startDate = new Date(date);

                                                    const endDate = new Date(startDate);
                                                    endDate.setDate(endDate.getDate() + 1);

                                                    this.setState(prevState => ({
                                                        product: {
                                                            ...prevState.product,
                                                            startDate: startDate.toISOString(),
                                                            endDate: endDate.toISOString()
                                                        }
                                                    }));

                                                    if (this.endDatePicker) {
                                                        this.endDatePicker.handleDaySelect(new Date(this.state.product.endDate));
                                                    }
                                                }}
                                            />
                                            <InputFeedback feedbackText={feedback.productDate} id='startDate' />
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </Col>
                                        <Col>
                                            <Label htmlFor='endDate' className="required-hint mt-4"><strong>End Date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={this.state.readOnly}
                                                className="input-date"
                                                defValue={!product.endDate ? "" : formatInTimeZoneDate(product.endDate, product.branchIanaTimeZoneId).substring(0, 10)}
                                                label="End Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                            <InputFeedback feedbackText={feedback.productDate} id='endDate' />
                                            <span className="help-block-calendar">{validation.endDate.message}</span>
                                        </Col>
                                    </Row>}

                                    {this.state.readOnly &&
                                        <Row form>
                                            <Col>
                                                <Label htmlFor='_startDate' className="mt-4"><strong>Start Date</strong></Label>
                                                <Input
                                                    id="_startDate"
                                                    readOnly={true}
                                                    className=''
                                                    value={this.state._startDate}>
                                                </Input>

                                            </Col>
                                            <Col>
                                                <Label htmlFor='_endDate' className="mt-4"><strong>End Date</strong></Label>
                                                <Input
                                                    id="_endDate"
                                                    readOnly={true}
                                                    className=''
                                                    value={this.state._endDate}>
                                                </Input>
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Row>
                                    <Col className="text-right float-bottom d-flex flex-wrap justify-content-end flex-row">
                                        <Button onClick={this.handleSubmit.bind(this)} type="submit" className={this.state.readOnly || !this.props.publicSiteBaseUrl ? 'd-none' : 'mail-btn ml-2'}>PREVIEW</Button>
                                        <Button onClick={this.handleCancel.bind(this)} className="mx-2 cancel-btn">CANCEL</Button>
                                        <Button onClick={this.handleEdit.bind(this)} className={this.state.readOnly ? 'mail-btn ml-4' : 'd-none'}>EDIT</Button>
                                        <Button onClick={this.handleFormSubmit.bind(this)} type="submit" color="primary" className={this.state.readOnly ? 'd-none' : 'mail-btn ml-2'}>SAVE</Button>
                                    </Col>
                                </Row>
                                {!this.state.originalPrimary &&
                                    <Row>
                                        <Col className="text-right float-bottom d-flex flex-wrap justify-content-center flex-row">
                                            <Button onClick={this.handleResettoPrimary.bind(this)} className={this.state.readOnly ? 'd-none' : 'reset-btn'}>RESET TO MATCH PRIMARY</Button>
                                        </Col>
                                    </Row>
                                }
                            </div>
                        </div>
                    </Form>
                    {/* Divider */}
                    <Col>
                        <hr />
                    </Col>
                    <Col>
                        <Row>
                            <div className="col-md-1">
                                <div className="inline-label"><strong>ID</strong></div>
                                <p className="editFooterText">{product.productId}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created by</strong></div>
                                <p className="editFooterText">{product.createdBy}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created date</strong></div>
                                <p className="editFooterText">{formatInTimeZoneDateTime(product.createdDate, product.branchIanaTimeZoneId)}</p>
                            </div>
                            <div className="col-md-2">
                                <div className="inline-label"><strong>Updated by</strong></div>
                                <p className="editFooterText">{product.updatedBy}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Updated date</strong></div>
                                <p className="editFooterText">{formatInTimeZoneDateTime(product.updatedDate, product.branchIanaTimeZoneId)}</p>
                            </div>
                        </Row>
                    </Col>
                </div >}
            </div>
        );
    }

}

export default connect(
    state => {
        return {
            updateResult: state.data.updateResult,
            branches: state.data.branches,
            publicSiteBaseUrl: state.data.settings.value && state.data.settings.value.publicSiteBaseUrl,
        }
    },
    dispatch => ({
        getProduct: (callback, context, id) => { dispatch(getProduct(callback, context, id)) },
        getBranches: (callback, context) => { dispatch(getBranches(callback, context)) },
        updateProduct: (callback, context) => { dispatch(updateProduct(callback, context)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) }
    }
    )
)(ProductEdit);